import http from '../../../../api/http';
import type { EjercicioContable, PeriodoContable } from '../types/ejercicio';

const ENDPOINTS = {
  EJERCICIOS: '/contabilidad/ejercicios',
  PERIODOS: '/contabilidad/periodos',
};

export class EjercicioService {
  public static async getAll(): Promise<EjercicioContable[]> {
    const response = await http.get(ENDPOINTS.EJERCICIOS);
    return response.data;
  }

  public static async getById(id: number): Promise<EjercicioContable> {
    const response = await http.get(`${ENDPOINTS.EJERCICIOS}/${id}`);
    return response.data;
  }

  public static async create(anio: number): Promise<EjercicioContable> {
    const response = await http.post(ENDPOINTS.EJERCICIOS, { anio });
    return response.data;
  }

  public static async cerrar(id: number): Promise<EjercicioContable> {
    const response = await http.put(`${ENDPOINTS.EJERCICIOS}/${id}/cerrar`);
    return response.data;
  }

  public static async getPeriodos(idEjercicio: number): Promise<PeriodoContable[]> {
    const response = await http.get(`${ENDPOINTS.PERIODOS}/ejercicio/${idEjercicio}`);
    return response.data;
  }

  public static async cerrarPeriodo(idPeriodo: number): Promise<PeriodoContable> {
    const response = await http.put(`${ENDPOINTS.PERIODOS}/${idPeriodo}/cerrar`);
    return response.data;
  }

  public static async abrirPeriodo(idPeriodo: number): Promise<PeriodoContable> {
    const response = await http.put(`${ENDPOINTS.PERIODOS}/${idPeriodo}/abrir`);
    return response.data;
  }
}
